import React from 'react'
import { FaLinkedin } from "react-icons/fa";
import { BsPersonFill } from "react-icons/bs";
import '../scss/variables.scss'
import '../scss/reset.scss'
import './Chi_siamo.scss'
import NavbarLogo from '../components/NavbarLogo/NavbarLogo'
import Footer from '../components/Footer/Footer'
import Sidemenu from '../components/Sidemenu/Sidemenu'

/* ===IMGS=== */
import SciariniImg from '../assets/images/SciariniImg.png'
import FrisonImg from '../assets/images/FrisonImg.png'

function Chi_siamo() {
    
    return (
        <>
            <Sidemenu path1="/" name1="Home" path2="/progetto" name2="Il Progetto" path3="/supportaci" name3="Supportaci" path4="/community" name4="Community"/>
            <NavbarLogo />
            <main id="chiSiamo">
                <h1>Chi Siamo</h1>

                <div className="staffContainer">
                    <div className="singleStaff">
                        <img src={SciariniImg} className="profileImg" alt="Luca Sciarini" />
                        <div className="infoStaff">
                            <div className="nameStaff">
                                <h2>Luca Sciarini</h2>
                                <a href="https://www.linkedin.com/in/luca-sciarini-775b13201/" target="_blank" rel="noopener noreferrer">
                                    <FaLinkedin className="LinkedinIcon"/>
                                </a>
                                <a href="https://losciar.web.app/" target="_blank" rel="noopener noreferrer">
                                    <BsPersonFill className="LinkedinIcon"/>
                                </a>
                            </div>
                            <h3>Founder</h3>
                            <p>Studente e sviluppatore WEB, fondatore e designer della piattaforma di studio FADY</p>
                        </div>
                    </div>
                    <div className="singleStaff">
                        <img src={FrisonImg} className="profileImg" alt="Alessio Frison" />
                        <div className="infoStaff">
                            <div className="nameStaff">
                                <h2>Alessio Frison</h2>
                                <a href="https://www.linkedin.com/in/alessio-frison-4ab553185/" target="_blank" rel="noopener noreferrer">
                                    <FaLinkedin className="LinkedinIcon"/>
                                </a>
                            </div>
                            <h3>Founder</h3>
                            <p>Studente e sviluppatore WEB, fondatore e gestore server della piattaforma di studio FADY</p>
                        </div>
                    </div>
                    
                </div>

            </main>
            <Footer />
        </>
    )
}

export default Chi_siamo
